"use client"

import { useEffect, useRef } from "react"
import { getRouteApi } from "@tanstack/react-router"
import { clientError } from "./server/use-error-log.functions"

const rootRoute = getRouteApi("__root__")

const normalizeErrorForLog = (error: unknown): { message: string; stack?: string } => {
  if (error instanceof Error) {
    return {
      message: error.message,
      stack: error.stack,
    }
  }

  if (typeof error === "string") {
    return { message: error }
  }

  return { message: "Unknown client error" }
}

export const useErrorLog = (error: unknown, message?: string, source = "client-error") => {
  const lastSentKeyRef = useRef<string>("")
  const rootData = rootRoute.useLoaderData()
  const loggedIn = !!rootData.loggedIn

  useEffect(() => {
    if (error == null && !message) {
      return
    }

    const normalized = normalizeErrorForLog(error ?? message)
    const effectiveMessage = message || normalized.message
    const sentKey = `${source}|${effectiveMessage}|${normalized.stack || ""}`

    if (lastSentKeyRef.current === sentKey) {
      return
    }

    lastSentKeyRef.current = sentKey

    void clientError({
      data: {
        errorMessage: effectiveMessage,
        stack: normalized.stack,
        source,
        route: typeof window !== "undefined" ? window.location.pathname : undefined,
        loggedIn,
      },
    })
  }, [error, message, source, loggedIn])
}
